import {RandomFactory} from 'md-library-test-first-version';

export const Providers = [
    RandomFactory
];
